import type { DealerFitsActions, DealerFitsState, StoreSlice } from '../types'

const initialDealerFitsState: DealerFitsState = {
  dealerFitsChecked: true,
  selectedDealerOptions: []
} as const

export const createDealerFitsSlice: StoreSlice<
  DealerFitsState & DealerFitsActions
> = set => ({
  // State
  ...initialDealerFitsState,

  // Actions
  setDealerFitsChecked: val =>
    set({ dealerFitsChecked: val }, false, 'setDealerFitsChecked'),

  toggleDealerFitChecked: () =>
    set(
      state => ({ dealerFitsChecked: !state.dealerFitsChecked }),
      false,
      'toggleDealerFitChecked'
    ),

  setSelectedDealerOptions: val =>
    set({ selectedDealerOptions: val }, false, 'setSelectedDealerOptions'),

  onRemoveArchivedDealerOption: id =>
    set(
      state => ({
        selectedDealerOptions: state.selectedDealerOptions.map(opt => ({
          ...opt,
          checked: opt.id === id ? false : opt.checked
        }))
      }),
      false,
      'onRemoveArchivedDealerOption'
    ),
  resetDealerFits: () => set(initialDealerFitsState, false, 'resetDealerFits')
})
